/**
 * Tenant storefronts use hostnames like `{slug}.giftygen.com`. Relative `/api` URLs hit that
 * host; many deployments only proxy `/api` on the apex domain, which yields 404 on subdomains.
 * Use the apex origin for API calls when the SPA runs on a business subdomain.
 *
 * Set REACT_APP_API_URL (e.g. https://giftygen.com) to override in any environment.
 */
export function getApiOrigin() {
  const env =
    typeof process !== "undefined" && process.env && process.env.REACT_APP_API_URL
      ? String(process.env.REACT_APP_API_URL).trim()
      : "";
  if (env) {
    return env.replace(/\/$/, "");
  }
  if (typeof window === "undefined") return "";
  const { protocol, hostname } = window.location;
  if (hostname === "localhost" || hostname === "127.0.0.1") return "";
  const parts = hostname.split(".");
  if (parts.length <= 2) return "";
  const first = parts[0].toLowerCase();
  if (first === "www") return "";
  const apexHost = parts.slice(-2).join(".");
  return `${protocol}//${apexHost}`;
}

/** Absolute URL for an API path (leading slash required on path). */
export function apiUrl(path) {
  const origin = getApiOrigin();
  const p = path.startsWith("/") ? path : `/${path}`;
  return origin ? `${origin}${p}` : p;
}
